import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { BsPlayCircle } from 'react-icons/bs';

interface MidiaModalProps {
    show: boolean;
    onHide: () => void;
    midiaUrl: string | null;
    tipo: 'video' | 'image';
    titulo: string;
}

const MidiaModal: React.FC<MidiaModalProps> = ({ show, onHide, midiaUrl, tipo, titulo }) => {
    return (
        <Modal show={show} onHide={onHide} size="lg" centered>
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title>
                    <BsPlayCircle className="me-2" />
                    {titulo}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center p-0">
                {midiaUrl && (
                    tipo === 'video' ? (
                        <video controls width="100%" className="rounded-bottom">
                            <source src={midiaUrl} type="video/mp4" />
                            Seu navegador não suporta o elemento de vídeo.
                        </video>
                    ) : (
                        <img 
                            src={midiaUrl} 
                            alt="Candidato" 
                            style={{ width: '100%', maxHeight: '80vh', objectFit: 'contain' }} 
                            className="rounded-bottom"
                        />
                    )
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default MidiaModal;
